import React from 'react';
import Hero from '../../components/sections/Hero';
import CategorySection from '../../features/home/components/CategorySection';
import FitnessCarousel from '../../features/home/components/FitnessCarousel';
import { Card, Row, Col, Typography, Button, Avatar, Rate } from 'antd';
import { FireOutlined, HeartFilled, ThunderboltFilled, SmileFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const gyms = [
  {
    name: 'AquaFit Swimming Club',
    address: '234 Võ Nguyên Giáp, Ngũ Hành Sơn, Đà Nẵng',
    image: 'https://cdn.prod.website-files.com/643de7c06cb87b2c7cee0b14/6492553b54274f9c46029922_647966ac6c535950141cccb5_te-rapa-hero-new.jpeg',
    rating: 4.8,
  },
  {
    name: 'Student Gym',
    address: '123 Cách Mạng Tháng 8, Cẩm Lệ, Đà Nẵng',
    image: 'https://www.danang43.vn/wp-content/uploads/2024/05/strong-body-fitness.jpg',
    rating: 4.7,
  },
  {
    name: 'Zen Yoga Studio',
    address: '789 Lê Duẩn, Hải Châu, Đà Nẵng',
    image: 'https://ptfitness.vn/wp-content/uploads/2022/12/setup-office-gym-mixicorp-cho-toc-truong-do-mixi-3.jpg',
    rating: 4.9,
  },
];

const benefits = [
  {
    icon: <FireOutlined style={{ color: '#FF9800', fontSize: 32 }} />,
    title: 'Đa dạng phòng tập',
    desc: 'Kết nối hàng trăm phòng gym chất lượng trên toàn quốc.',
  },
  {
    icon: <HeartFilled style={{ color: '#d32f2f', fontSize: 32 }} />,
    title: 'Tiện lợi & nhanh chóng',
    desc: 'Đặt gói tập, thanh toán online, check-in dễ dàng chỉ với vài thao tác.',
  },
  {
    icon: <ThunderboltFilled style={{ color: '#388e3c', fontSize: 32 }} />,
    title: 'Ưu đãi hấp dẫn',
    desc: 'Nhiều chương trình giảm giá, tặng quà cho thành viên mới.',
  },
];

const reviews = [
  {
    name: 'Nguyễn Văn A',
    avatar: 'https://cdn-icons-png.flaticon.com/512/219/219986.png',
    comment: 'Trang này giúp mình tìm phòng gym gần nhà rất nhanh, đặt gói tập cũng tiện!',
    rate: 5,
  },
  {
    name: 'Trần Thị B',
    avatar: 'https://cdn-icons-png.flaticon.com/512/219/219969.png',
    comment: 'Nhiều ưu đãi, phòng tập chất lượng, mình rất hài lòng, mình sẽ giới thiệu với bạn bè của mình về website Mixi Fitness này.',
    rate: 5,
  },
  {
    name: 'Nguyễn Văn C',
    avatar: 'https://cdn-icons-png.flaticon.com/512/219/219986.png',
    comment: 'Trang này giúp mình tìm phòng gym gần nhà rất nhanh, đặt gói tập cũng tiện!',
    rate: 5,
  }
];

const HomePage = () => {
  const handleCategorySelect = (category) => {
    console.log(`Selected category: ${category}`);
  };
  const navigate = useNavigate();

  const handleCarouselItemClick = (item) => {
    console.log('Clicked item:', item);
  };

  return (
    <>
      <Hero heroImage="/images/banner1.jpg" />

      <div className="container" style={{ marginTop: 32 }}>
        {/* Giới thiệu */}
        <Row justify="center" style={{ marginBottom: 32 }}>
          <Col xs={24} md={20} lg={16}>
            <Title level={2} style={{ color: '#FF9800', textAlign: 'center', fontWeight: 700 }}>
              Nền tảng kết nối phòng gym & người tập hiện đại
            </Title>
            <Paragraph style={{ textAlign: 'center', fontSize: 18, color: '#444' }}>
              Tìm kiếm, đặt gói tập, trải nghiệm hàng trăm phòng gym chất lượng chỉ với một nền tảng duy nhất.
            </Paragraph>
          </Col>
        </Row>

        {/* Lợi ích */}
        <Row gutter={[24, 24]} justify="center" style={{ marginBottom: 40 }}>
          {benefits.map((b, idx) => (
            <Col xs={24} sm={8} key={idx}>
              <Card
                bordered={false}
                style={{
                  textAlign: 'center',
                  borderRadius: 16,
                  boxShadow: '0 4px 24px #ff980033',
                  minHeight: 180,
                }}
              >
                <div style={{ marginBottom: 12 }}>{b.icon}</div>
                <Text strong style={{ fontSize: 18 }}>{b.title}</Text>
                <Paragraph style={{ color: '#666', marginTop: 8 }}>{b.desc}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Danh mục & carousel */}
        <CategorySection
          categories={['Đi bộ', 'Chạy bộ', 'Đẩy tạ', 'Yoga', 'Gym']}
          onCategorySelect={handleCategorySelect}
        />
        <FitnessCarousel onItemClick={handleCarouselItemClick} />

        {/* Gym nổi bật */}
        <Title level={3} style={{ color: '#FF9800', marginTop: 48, marginBottom: 24 }}>
          Phòng gym nổi bật
        </Title>
        <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
          {gyms.map((gym, idx) => (
            <Col xs={24} sm={12} md={8} key={idx}>
              <Card
                hoverable
                cover={<img alt={gym.name} src={gym.image} style={{ height: 180, objectFit: 'cover', borderRadius: 12 }} />}
                style={{
                  borderRadius: 16,
                  boxShadow: '0 4px 24px #ff980033',
                  minHeight: 320,
                }}
              >
                <Title level={4} style={{ color: '#F15637', marginBottom: 4 }}>{gym.name}</Title>
                <Text type="secondary">{gym.address}</Text>
                <div style={{ marginTop: 8 }}>
                  <Rate disabled defaultValue={gym.rating} allowHalf style={{ color: '#FF9800', fontSize: 18 }} />
                  <span style={{ marginLeft: 8, color: '#888' }}>{gym.rating}</span>
                </div>
                {/* <Button type="primary" style={{ marginTop: 16, background: '#FF9800', border: 'none' }}>
                  Xem chi tiết
                </Button> */}
              </Card>
            </Col>
          ))}
        </Row>

        {/* Đánh giá khách hàng */}
        <Title level={3} style={{ color: '#388e3c', marginBottom: 24 }}>
          Khách hàng nói gì về chúng tôi?
        </Title>
        <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
          {reviews.map((r, idx) => (
            <Col xs={24} sm={12} md={8} key={idx}>
              <Card
                bordered={false}
                style={{
                  borderRadius: 16,
                  boxShadow: '0 4px 24px #ff980033',
                  minHeight: 180,
                  textAlign: 'center'
                }}
              >
                <Avatar src={r.avatar} size={64} style={{ marginBottom: 12 }} />
                <Paragraph style={{ fontStyle: 'italic', color: '#444' }}>"{r.comment}"</Paragraph>
                <Text strong>{r.name}</Text>
                <div>
                  <Rate disabled defaultValue={r.rate} style={{ color: '#FF9800', fontSize: 16, marginTop: 4 }} />
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {/* CTA */}
        <div style={{ textAlign: 'center', margin: '48px 0 32px 0' }}>
          <Button
            type="primary"
            size="large"
            onClick={() => navigate('/packages')}
            style={{
              background: 'linear-gradient(90deg, #FF9800 60%, #F15637 100%)',
              border: 'none',
              borderRadius: 24,
              fontWeight: 700,
              fontSize: 20,
              padding: '12px 48px',
              boxShadow: '0 4px 24px #ff980033'
            }}
          >
            Đăng ký thành viên ngay
          </Button>
        </div>
      </div>
    </>
  );
};

export default HomePage;